import type {IIdSelection} from '../../types';

/**
 * Get the total number of selected items from a virtualized selection.
 *
 * @typeParam S - Selection type (infered)
 *
 * @param selection Selection to get the total from.
 * @param total Total number of items.
 * @returns Total number of selected items.
 *
 * @example
 * ```ts
 * getTotalSelectedFromVirtualizedSelection(
 * 	{
 * 		all: true,
 * 		excludeIds: [],
 * 		includeIds: [],
 * 	},
 * 	10,
 * ); // 10
 * ```
 */
export const getTotalSelectedFromVirtualizedSelection = <
	S extends IIdSelection<number | string>,
>(
	selection: S,
	total: number,
) =>
	Math.min(
		Math.max(
			selection.all
				? total - selection.excludeIds.length
				: selection.includeIds.length,
			0,
		),
		total,
	);
